import Badge from "react-bootstrap/Badge";

export function MemberBadge({isOwner}){
    return (
        <Badge data-cy="membership-badge" pill bg={isOwner?"success":"secondary"}>
            {isOwner?"Owner":"Member"}
        </Badge>
    )
}